var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntelligentRouting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_760",
    "data-name": "Group 760",
    transform: "translate(-1204.5 -1539)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_372",
    "data-name": "Rectangle 372",
    width: 58,
    height: 58,
    transform: "translate(1204.5 1539)",
    fill: "none",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_759",
    "data-name": "Group 759"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_758",
    "data-name": "Group 758"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    d: "M1233.657,1590.927a5.889,5.889,0,0,1-5.9-5.889v-8.461a1.348,1.348,0,0,1,2.7,0v8.461a3.192,3.192,0,0,0,3.239,3.193,3.257,3.257,0,0,0,3.147-3.294v-3.928a5.962,5.962,0,0,1,5.811-5.99h4.9a1.348,1.348,0,1,1,0,2.7h-4.882a3.253,3.253,0,0,0-3.132,3.294v3.928a5.964,5.964,0,0,1-5.811,5.99Z",
    fill: "#847dff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_756",
    "data-name": "Group 756"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1193",
    "data-name": "Path 1193",
    d: "M1230.451,1565.78h-2.7v-10.2a5.637,5.637,0,0,0-1.683-4,5.454,5.454,0,0,0-9.265,3.908v4.371h-2.7v-4.371a8.14,8.14,0,0,1,13.849-5.832,8.35,8.35,0,0,1,2.492,5.922Z",
    fill: "#847dff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_755",
    "data-name": "Group 755"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M1225.07,1564.6l4.033,6.984,4.033-6.984Z",
    fill: "#847dff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    d: "M1252.4,1555.259a5.058,5.058,0,1,1,5.059-5.058A5.064,5.064,0,0,1,1252.4,1555.259Zm0-7.42a2.362,2.362,0,1,0,2.362,2.362A2.364,2.364,0,0,0,1252.4,1547.839Z",
    fill: "#847dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    d: "M1252.4,1568.338a5.057,5.057,0,1,1,5.059-5.058A5.064,5.064,0,0,1,1252.4,1568.338Zm0-7.419a2.362,2.362,0,1,0,2.362,2.361A2.364,2.364,0,0,0,1252.4,1560.919Z",
    fill: "#847dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    d: "M1252.4,1581.417a5.057,5.057,0,1,1,5.059-5.058A5.064,5.064,0,0,1,1252.4,1581.417Zm0-7.419a2.361,2.361,0,1,0,2.362,2.361A2.363,2.363,0,0,0,1252.4,1574Z",
    fill: "#847dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    d: "M1239.534,1581.662h-2.7V1567.9a5.962,5.962,0,0,1,5.811-5.99h4.9v2.7h-4.882a3.253,3.253,0,0,0-3.132,3.294Z",
    fill: "#847dff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    d: "M1239.534,1567.256h-2.7v-12.381a5.963,5.963,0,0,1,5.811-5.991h4.9v2.7h-4.882a3.253,3.253,0,0,0-3.132,3.3Z",
    fill: "#847dff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_757",
    "data-name": "Group 757"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    "data-name": "Path 1200",
    d: "M1220.266,1563.26h-9.616a2.153,2.153,0,0,0-2.152,2.153v9.615a2.153,2.153,0,0,0,2.152,2.153h9.616a2.153,2.153,0,0,0,2.153-2.153v-9.615A2.153,2.153,0,0,0,1220.266,1563.26Z",
    fill: "#847dff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    d: "M1214.06,1568.92v.878h-2.1v-.878a1.049,1.049,0,1,1,2.1,0Zm1.218,0a2.267,2.267,0,0,0-4.535,0v4.259a.609.609,0,1,0,1.219,0v-2.163h2.1v2.163a.609.609,0,1,0,1.218,0Zm3.707,3.358v-4.09h.579a.609.609,0,1,0,0-1.218h-2.375a.609.609,0,1,0,0,1.218h.578v4.09h-.578a.609.609,0,1,0,0,1.218h2.375a.609.609,0,1,0,0-1.218Z",
    fill: "#1c182a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1202",
    "data-name": "Path 1202",
    d: "M1215.458,1588.461h0a1.349,1.349,0,0,1-1.348-1.348V1580.7h2.7v6.411A1.348,1.348,0,0,1,1215.458,1588.461Z",
    fill: "#847dff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntelligentRouting);
export default __webpack_public_path__ + "static/media/intelligent-routing.af95d1854576692b038e97a5a65cb1bb.svg";
export { ForwardRef as ReactComponent };